__turbopack_context__.v({
  "accordion": "accordion-module__oWC9Da__accordion",
  "arrow": "accordion-module__oWC9Da__arrow",
  "content": "accordion-module__oWC9Da__content",
  "item": "accordion-module__oWC9Da__item",
  "note": "accordion-module__oWC9Da__note",
  "summary": "accordion-module__oWC9Da__summary",
  "title": "accordion-module__oWC9Da__title",
});
